import React from 'react';
import { AppBar, Toolbar, Button, Box, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    const handleNavClick = (path) => {
        navigate(path);
    };

    return (
        <AppBar position="static" color="primary" sx={{ top: 'auto', bottom: 0, width: '100%', mt: 4 }}>
            <Toolbar sx={{ justifyContent: 'space-between', pt: 2 }}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item xs={12} md={4}>
                        <Box sx={{ textAlign: 'left' }}>
                            <Typography variant="body2" component="div">
                                © 2024 Type Copy. All rights reserved.
                            </Typography>
                            <Typography variant="body2" component="div">
                                Made By Type Copy Team.
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button color="inherit" onClick={() => handleNavClick('/terms-of-service')}>Terms of Service</Button>
                        <Button color="inherit" onClick={() => handleNavClick('/privacy-policy')}>Privacy Policy</Button>
                        <Button color="inherit" onClick={() => handleNavClick('/cookie-policy')}>Cookie Policy</Button>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button color="inherit" onClick={() => handleNavClick('/contact-us')}>Contact Us</Button>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;